import { encrypt ,decrypt } from '../../utils/encryptiondecryption';
import { key } from '../../utils/encryptiondecryption';
 import Cookies from 'js-cookie';import React from 'react';
import {Link} from 'react-router-dom';
import ImageWebp from 'react-image-webp';
import Constant from "../../utils/Constant";
import LocalStorageService from "../../utils/LocalStorageService";
import axios from 'axios';
import $ from 'jquery';
import Header from "../common/Header";
class RelatedMODFilter extends React.Component{
    // this component is same as RelatedVODFilter replicated to change appearence for movies and api's are also different
    constructor() {

    
        super();
        
        const ciphertext = Cookies.get('YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD');
        
        const decryptedText = decrypt(ciphertext, key);
        
        this.handleTypes = this.handleTypes.bind(this);
        this.handlechannelList = this.handlechannelList.bind(this);
        this.callApi = this.callApi.bind(this);        
        this.state = {
        auth: {
            device_id: decryptedText.length > 1 ? (decryptedText[0][1] === 'null' ? null : decryptedText[0][1]) : null,
            phone_details: decryptedText.length > 1 ? (decryptedText[1][1] === 'null' ? null : decryptedText[1][1]) : null,
            user_id: decryptedText.length > 1 ? (decryptedText[2][1] === 'null' ? null : decryptedText[2][1]) : null,
            mobile: decryptedText.length > 1 ? (decryptedText[3][1] === 'null' ? null : decryptedText[3][1]) : null,
            package_id: decryptedText.length > 1 ? (decryptedText[4][1] === 'null' ? null : decryptedText[4][1]) : null,
            subscription_expiry_datetime: decryptedText.length > 1 ? (decryptedText[5][1] === 'null' ? null : decryptedText[5][1]) : null,
        },
                    
            listDatas : {
                isLoaded: false,
                list: {},
            } 
        }
    }

    componentDidMount(){
        $("#relatedtab").addClass('active');
        var data= {search: "all",user_id:localStorage.getItem("user_id")}; 
        this.callApi(data)
    }

    componentWillReceiveProps(){
        // var data= {slug: this.props.slug};
        // this.callApi(data)

    }

    clickTypes = (type,selectorVal) =>{
        $("#filterrelated>ul>li>a.active").removeClass("active");        
        $("#"+selectorVal).addClass('active');
        this.setState({
            listDatas: {
              isLoaded: false              
            }
          })
        var data= {type: type,user_id:localStorage.getItem("user_id")};
        this.callApi(data)
    }

    clickAll = () =>{
        $("#filterrelated>ul>li>a.active").removeClass("active");
        $("#relatedtab").addClass('active');
        var data= {search: "all",user_id:localStorage.getItem("user_id")}; 
        this.callApi(data)
    }    

    handleTypes = () => {        
        let types = "";
        let classRef = this;
        // console.log("props data: ", this.props.data);
        types = this.props.data.map((type,index) => (
            <li><a id={"type_"+index} onClick={() => this.clickTypes(type.id,"type_"+index)}>{type.type}</a></li>
        ));                        
        return types;
    };

    callApi = (data) => {
        let classRef = this;
        let user_id = this.state.auth.user_id;        
        axios({
            method: 'POST',
            // url: Constant.url+"get-releated-channels",
            url: Constant.url+"get-releated-movies",
            data: data,
            headers: {'Authorization': "bearer " + localStorage.getItem("access_token")}
        }).then(function (result) {
            let response = {};
            response["data"] = JSON.parse(LocalStorageService.decryptAes(result.data.eData));
            if(response.data.code === 200){
                // console.log("sidebar data: ", response.data);
                
                classRef.setState({
                    listDatas:{
                        isLoaded : true,
                        list: response.data.data.channels
                    }
                })
            }
        }).then(function (response) {
            
        });
      };
      
      addToFavourite = (heart_id, channelId) => {
        
        if (!this.state.auth.user_id) {
          new Header().openLoginModal();
          return;
        }
        if ($("#" + heart_id).hasClass('active')) {
    
          $("#heart_" + channelId).removeClass('active')
          $("#" + heart_id).removeClass('active');
          let classRef = this;
          axios({
            method: 'POST',
            url: Constant.url + "remove-favourite",
            headers: { 'Authorization': "bearer " + localStorage.getItem("access_token") },
            data: { id: channelId, user_id: this.state.auth.user_id,type: "channel" },
          }).then(function (result) {
            let response = {};
            response["data"] = JSON.parse(LocalStorageService.decryptAes(result.data.eData));
            
            if (response.data.code === 200 && response.data.status === true) {
    
    
            }
          })
        } else {
          $("#" + heart_id).addClass('active');
          $("#heart_" + channelId).addClass('active')
          let params = JSON.stringify({ channel_id: channelId, user_id: this.state.auth.user_id });
          let classRef = this;
          axios({
            method: 'POST',
            url: Constant.url + "add-user-favourite-channels-2",
            headers: { 'Authorization': "bearer " + localStorage.getItem("access_token") },
            // data: { dataparams: LocalStorageService.encryptAes(params)},
            data: { channel_id: channelId, user_id: localStorage.getItem("user_id") },
          }).then(function (result) {
            let response = {};
            response["data"] = JSON.parse(LocalStorageService.decryptAes(result.data.eData));
            
            if (response.data.code === 200 && response.data.status === true) {
    
            }
          })
        }
      }    

    handlechannelList = () => {
        let channels = "";
        // console.log("channels list", this.state.listDatas.list);
        channels = this.state.listDatas.list.map((channel,index) => (
            <li key={index}>
                <div className="live_style live_style_full">
                    <Link className="fav_sld_img" to={"/movies/" + channel.channel_slug}>
                        {/* <ImageWebp className="img_log" webp={channel.channel_logo} src={channel.channel_logo_jpg} alt={channel.channel_name}/>  */}
                        {/* <ImageWebp webp={channel.channel_live_image} src={channel.channel_live_image_jpg} alt={channel.channel_name}/> */}
                        <img src={"https://www.mjunoon.tv/" + channel.channel_poster} alt={channel.channel_name} className='' onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src = "data:image/png;base64,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";
                            }}/>
                        <h4>{channel.channel_name}</h4>
                        <span className="views_txt">{channel.channel_views}</span>
                    </Link>
                        
                </div>
            </li>
        ));                
        // $('.edit_btn').click(function(){console.log('javed');});
        return channels;
    };


    render(){
        return (
            <div className="RelatedFilter RelatedMoviesFilter">
                 <div id="filterrelated" className="RelatedFilterBtns" uk-slider="finite: true">
                    <ul class="uk-slider-items">
                        <li><a id="relatedtab" onClick={this.clickAll}>All</a></li>
                        {this.handleTypes()}
                    </ul>
                    <a className="RelatedFilterPrev" href="#" uk-slider-item="previous"><span uk-icon="icon: chevron-left"></span></a>
                    <a className="RelatedFilterNext" href="#" uk-slider-item="next"><span uk-icon="icon: chevron-right"></span></a>
                 </div>
                 <div className="RelatedFilterBox RelatedMoviesFilterBox">
                     <ul>
                        {this.state.listDatas.isLoaded ? this.handlechannelList():<div className="loader_box"><div className="loader"><div className="loader_inner"></div></div></div>}
                     </ul>
                 </div>
            </div>
        );
    }
}

export default RelatedMODFilter;